export default __webpack_public_path__ + "static/media/cuvette_rack_long.5733f4bf.svg";